import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useUsersStore} from '../UsersStore';
import AddButton from './addButton';

function HeaderView(props) {
  const {state: usersStore} = useUsersStore();

  return (
    <div className="row mt-4 mb-5">
      <h1 className="col-md-6 m-0">
        <Translate value="organisation.users.title"/>
        <span className="separator information">{usersStore.totalCount}</span>
      </h1>
      <div className="col-md-6 inline-container flex-end">
        <Translate
          value="organisation.remainingUserAccounts"
          count={props.userSlotsLeft}
        />
        <AddButton
          hasSubscription={props.hasSubscription}
          hasUserSlotsLeft={props.userSlotsLeft > 0}
          onClick={props.onAddClient}
        />
      </div>
    </div>
  );
}

HeaderView.propTypes = {
  hasSubscription: PropTypes.bool.isRequired,
  userSlotsLeft: PropTypes.number.isRequired,
  onAddClient: PropTypes.func.isRequired
};

export default HeaderView;
